// extracted by mini-css-extract-plugin
export default {"settings":"YBr3W","button":"zRm_K"};